// Self-hosted Umami instance. The site id is also inlined in the client
// tracker script (src/routes/__root.tsx) - kept here as the single source of
// truth so the server-side tracker (server-track.ts) can't drift from it.
export const UMAMI_WEBSITE_ID = 'b0c5f008-00f6-4141-a58e-30c1613ce9b6'
export const UMAMI_COLLECT_URL = 'https://analytics.countact.fr/api/send'
